<template>
  <fragment>
    <ConfigureModalityForm
      :value="value"
      :submodality="subModalityModel"
      :error-messages="limitCreditSubModalityErrorMessage"
      :prize-rules="prizeRules"
    >
      <template v-slot:header>
        <FormSection class="pt-3" :title="formSectionTitle">
          <v-col cols="12">
            <v-row>
              <v-col cols="12" sm="5" class="pr-sm-5">
                <BaseFormInput
                  placeholder="Selecionar"
                  label-text="Sub-Modalidade"
                  disabled
                  v-model="value.submodalidade.nome"
                  id-element="nameSubModality"
                />
              </v-col>
              <v-col cols="12" sm="7" class="pb-5" v-if="isEdit">
                <p class="form__label mb-5 primary--text">
                  Status
                </p>
                <v-switch
                  v-model="value.ativo"
                  class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
                  dense
                  inset
                  hide-details
                  color="secondary"
                />
                <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
                  {{ statusSubmodality }}
                </p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row v-if="runValidateModality">
              <v-col cols="12" sm="3" md="2" class="pr-sm-5">
                <BaseFormSelect
                  id-element="startCoverYearModality"
                  placeholder="Selecionar"
                  label-text="Cobertura Mínima (anos)"
                  :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                  v-model="value.prazo_cobertura_de"
                  required
                  :rules="[requiredInput, submodalityRuleMinTermCoverage]"
                />
              </v-col>
              <v-col
                cols="1"
                class="pr-5 justify-center align-center d-none d-sm-flex"
              >
                <p class="form__label mb-0 mt-sm-5 mt-xl-0">
                  à
                </p>
              </v-col>
              <v-col cols="12" sm="3" md="2" class="pr-sm-5">
                <BaseFormSelect
                  id-element="endCoverYearSubModality"
                  placeholder="Selecionar"
                  label-text="Cobertura Máxima (anos)"
                  :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                  v-model="value.prazo_cobertura_ate"
                  required
                  :rules="[requiredInput, submodalityRuleMaxTermCoverage]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" xl="2" class="pr-sm-5">
                <BaseFormInput
                  id-element="deadlineModality"
                  placeholder="Inserir"
                  label-text="Prazo Minuta em dias"
                  v-model="value.prazo_minuta_dias"
                  type="number"
                  required
                  :rules="[requiredInput]"
                />
              </v-col>
              <v-col cols="12" sm="3" xl="2" class="pr-sm-5">
                <BaseFormInput
                  id-element="deadlinePolicySubModality"
                  placeholder="Inserir"
                  label-text="Prazo Apólice em dias"
                  v-model="value.prazo_apolice_dias"
                  type="number"
                  required
                  :rules="[requiredInput]"
                />
              </v-col>
            </v-row>
          </v-col>
        </FormSection>
        <v-divider />
      </template>
    </ConfigureModalityForm>
    <BaseFooter>
      <div class="d-flex justify-end ">
        <BaseButton
          class="error text-uppercase subtitle-2 font-weight-bold"
          min-width="200"
          @click="$emit('cancel')"
        >
          CANCELAR
        </BaseButton>
        <BaseButton
          @click="$emit('save-step', 'submodality')"
          class="secondary text-uppercase subtitle-2 font-weight-bold ml-5"
          min-width="200"
        >
          SALVAR
        </BaseButton>
      </div>
    </BaseFooter>
  </fragment>
</template>

<script>
import ConfigureModalityForm from "../../../components/ConfigureModalityForm.vue";
import FormSection from "@/components/FormSection.vue";
import { requiredInput } from "@/utils/rules.js";
import { mapState } from "vuex";
import _ from "lodash";
export default {
  name: "ConfigureSubModality",
  components: { FormSection, ConfigureModalityForm },
  props: {
    subModalityModel: Object,
    modalityModel: Object,
    isEdit: Boolean,
    limitCreditSubModalityErrorMessage: Array,
    prizeRules: Array
  },
  previousStep() {
    return import("./ConfigureModality.vue").then(c => c.default);
  },
  data() {
    return {
      requiredInput,
      value: null,
      modalidade: null
    };
  },
  computed: {
    ...mapState("me", ["userAreaIsGarantia"]),
    statusSubmodality() {
      return this.value && this.value.ativo ? "Ativo" : "Inativo";
    },
    runValidateModality() {
      return this.modalityModel?.modalidade?.id == "judicial";
    },
    formSectionTitle() {
      return this.userAreaIsGarantia ? "LIMITE DE CRÉDITO" : "";
    }
    
  },
  created() {
    this.value = this.subModalityModel;
    this.modalidade = this.modalityModel;
    this.value.valor_limite_credito =
      this.value.valor_limite_credito == 0
        ? _.cloneDeep(this.modalityModel.valor_limite_credito)
        : this.value.valor_limite_credito;
  },
  methods: {
    submodalityRuleMinTermCoverage() {
      return (
        this.value.prazo_cobertura_de <= this.value.prazo_cobertura_ate ||
        "Cobertura mínima deve ser menor ou igual que corbertura máxima!"
      );
    },
    submodalityRuleMaxTermCoverage() {
      return (
        this.value.prazo_cobertura_de <= this.value.prazo_cobertura_ate ||
        "Cobertura máxima deve ser menor ou igual que corbertura mínima!"
      );
    }
  }
};
</script>
